import { AnyAction } from "redux";
import { Dispatch } from "react";
import { AnnouncementRaw, Result } from "../../../../interfaces";
import { Create } from "../../../announcements";
import { Adapter } from "../../../../shared/adapter";
import { AnnouncementsAdapter } from "../../../../adapter/announcements -adapter";

export const FETCH_CREATE_ANNOUNCEMENTS_REQUEST = 'FETCH_ANNOUNCEMENTS_REQUEST';
export const FETCH_CREATE_ANNOUNCEMENTS_SUCCESS = 'FETCH_ANNOUNCEMENTS_SUCCESS';
export const FETCH_CREATE_ANNOUNCEMENTS_FAILURE = 'FETCH_ANNOUNCEMENTS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchCreateAnnouncementsRequest = () => {
    return {
        type: FETCH_CREATE_ANNOUNCEMENTS_REQUEST,
    };
};

const fetchCreateAnnouncementsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_CREATE_ANNOUNCEMENTS_SUCCESS,
        payload: data
    };
};

const fetchCreateAnnouncementsFailure = (error: any) => {
    return {
        type: FETCH_CREATE_ANNOUNCEMENTS_FAILURE,
        payload: error,
    };
};

export const clear = ()=>{
    return {
        type: "CLEAR_DATA",
    };  
}

export const create = (announcements:AnnouncementRaw) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchCreateAnnouncementsRequest());
        try {
            const response = await Create(announcements);
            dispatch(fetchCreateAnnouncementsSuccess(
                Adapter.from(response.data).to((value) => new AnnouncementsAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchCreateAnnouncementsFailure(error.message));
        }
    };
};